import React from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { TooltipMapIcon } from 'components/UI/TooltipMapIcon';
import { getText } from 'services/languageService';
import { MapElementIcon } from 'components/UI/MapElementIcon';
import { IconButton } from '@mui/material';
import { toggleOpenDynamicSeriesAction } from 'store/actions/dynamicSeries';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
export const DynamicSeriesElement: React.FC = () => {
  const { dynamicYears } = useAppSelector((state) => state.dynamicSeries);

  const dispatch = useAppDispatch();
  const toggleOpenDynamicSeriesModal = () => {
    dispatch(toggleOpenDynamicSeriesAction());
  };

  return dynamicYears.length ? (
    <TooltipMapIcon title={getText('DYNAMIC_SERIES')}>
      <MapElementIcon
        id="ruler-btn"
        sx={{
          backgroundColor: (theme) => theme.palette.grey[500],
        }}
      >
        <IconButton
          disabled={!dynamicYears.length}
          onClick={toggleOpenDynamicSeriesModal}
        >
          <CalendarMonthIcon fontSize={'large'} sx={{ color: 'white' }} />
        </IconButton>
      </MapElementIcon>
    </TooltipMapIcon>
  ) : null;
};
